<template>
  <div>
    <card class="col-sm-12 col-lg-6">
      <b-row>
        <b-col cols="12">
          <div class="text-right">
            <b-button variant="primary" href="/#/admin/gateway"
              >New Gateway</b-button
            >
          </div>
        </b-col>
      </b-row>

      <table class="table mt-3 table-hover">
        <tr>
          <th>
            Version
          </th>
          <th>
            Description
          </th>

          <th></th>
        </tr>
        <tbody style="cursor:pointer">
          <tr
            v-for="item in gateways"
            v-bind:key="item.id"
            @click="goGateway(item.id)"
          >
            <td>{{ item.major }}.{{ item.minor }}.{{ item.revision }}</td>
            <td>
              {{ item.description }}
            </td>
          </tr>
        </tbody>
      </table>
    </card>
  </div>
</template>

<script>
export default {
  data() {
    return { gateways: [] };
  },
  async mounted() {
    var r = await this.$client.get("/api/gateway/getGateways");
    this.gateways = r.data.value;
  },
  methods: {
    goGateway(id) {
      location.href = "/#/admin/gateway?id=" + id;
    },
  },
};
</script>

<style></style>
